const queryGenerator = (queryObject) => {
  let query = "?";
  Object.entries(queryObject).forEach(([key, value]) => {
    if (value !== undefined) {
      query += `&${key}=${value}`;
    }
  });
  return query === "?" ? "" : query;
};

export default queryGenerator;
